import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo } from "vue"

const _hoisted_1 = { class: "avatar display-none-media-768 ml-2" }
const _hoisted_2 = { class: "text-raleway-20 t-blue mb-4 mt--3" }
const _hoisted_3 = { class: "container-avatar bg-white50" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "avatar-image bg-white50" }
const _hoisted_7 = { class: "btn-container-upload" }

import { UserTypeOperation } from '@/store/modules/User/type'
import { IUseFetchDetailError } from '@/hook/fetch/interface'
import { useFetch } from '@/hook/fetch/fetch'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'avatarComponent',
  setup(__props) {

const store = useStore()
const upload = ref(false)
const formData = ref<FormData | null>()
const userData = ref(computed<UserTypeOperation>(() => store.getters.getUserData))
const inputValue = ref<HTMLInputElement | null>()
const img = ref<string | ArrayBuffer | null>(null)

const onFileChanged = async (event: Event) => {
    event.preventDefault()
    if(!event.target) return
    
    inputValue.value = event.target as HTMLInputElement
    if(!inputValue.value.files) return
    const files = inputValue.value.files
    if (!files.length) return
    const reader = new FileReader()
    await reader.readAsDataURL(files[0])
    reader.onload = () => {
        img.value = reader.result
        const form = new FormData()
        form.append('photo_path', files[0], files[0].name)
        formData.value = form
        upload.value = true
    }
}
const removeData = () => {
    img.value = null
    formData.value = null
    if(inputValue.value && inputValue.value.value) inputValue.value.value = ''
    upload.value = false
}
const updateAvatar = async (event: Event) => {
    event.preventDefault()
    const { data, isLoading } = await useFetch<UserTypeOperation, IUseFetchDetailError>(process.env.VUE_APP_SERVER + 'api/users/' + store.getters.userIdGet  + '/', 'PUT', true, formData.value, true)
    await store.commit('updateUser', {data: data.value, isLoading})
    await removeData()
}
const removeAvatar = async (event: Event) => {
    event.preventDefault()
    removeData()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc('avatar')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        type: "file",
        accept: "image/*",
        class: "display-none",
        id: "file",
        name: "photo_path",
        onChange: onFileChanged
      }, null, 32),
      _withMemo([userData.value.photo_path, img.value], () => (_openBlock(), _createElementBlock("label", {
        for: "file",
        class: "wrapper-avatar pointer"
      }, [
        _withDirectives(_createElementVNode("img", {
          src: img.value?.toString() || '',
          alt: '',
          class: "avatar-image"
        }, null, 8, _hoisted_4), [
          [_vShow, upload.value]
        ]),
        _withDirectives(_createElementVNode("img", {
          src: img.value?.toString() || userData.value.photo_path || '',
          alt: userData.value.photo_path || '',
          class: "avatar-image"
        }, null, 8, _hoisted_5), [
          [_vShow, userData.value.photo_path && !upload.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
          [_vShow, (userData.value.photo_path === '' || !userData.value.photo_path) && !img.value]
        ])
      ])), _cache, 0)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("button", {
        class: "btn btn-default-inactive mb-1 mt-3 text-center",
        onClick: updateAvatar,
        type: "submit"
      }, "Upload new avatar", 512), [
        [_vShow, upload.value]
      ]),
      _withDirectives(_createElementVNode("button", {
        class: "btn btn-default-upload mb-1 m-auto img-btn-upload",
        onClick: removeAvatar
      }, "Remove", 512), [
        [_vShow, img.value]
      ])
    ])
  ]))
}
}

})